import Header from "../components/Header";
import "../style/ProjectWriteups.css";
import CaptionedImage from "../components/CaptionedImage";

export const FlowInTheFieldFrontend: React.FC = () => {
  return (
    <div>
      <Header />
      <div id="projectWriteUpWrapper">
        <div id="projectDetailsContainer">
          <h1>Flow in the Field Frontend</h1>
          <h2>
            SANDBOX APPLICATION, EXPLAIN FLOW IN THE FIELD
          </h2>
          <div className="goalContainer">
            <div>
              <h1>Initial Intention</h1>
              <div className="imageWithTextRow">
                <CaptionedImage
                  src={"/res/flowinthefield/startscreen.png"}
                  id={"initialmock"}
                  caption={"An initial visual mockup of PaperTrade"}
                />
                <p>
                  This project was completed as part of coursework for Object
                  Oriented Design, and was to be completed in pairs, my partner
                  being my good friend, roommate, and programmer, Brandon. the
                  functionality requirements of the project were not given all at
                  once, but were instead split into 3 separate assignments over
                  3 weeks. This was to encourage students to use MVC
                  architecture to create code that obeyed SOLID design
                  principles-such that upon receiving additional instructions,
                  modification of existing code ought to be minimized.
                  <br></br>
                  <br></br>
                </p>
              </div>
            </div>
          </div>
          <div className="developmentProcessContainer">
            <div>
              <h1>Development Process</h1>

              <div className="imageWithTextRow">
                <CaptionedImage
                  src={"/res/papertradeweb/pureJS.png"}
                  id={"pureJS"}
                  caption={
                    "HTML, CSS, Vanilla Javascript Implementation of PaperTrade"
                  }
                />
                <div>
                  <h2>Week 1 : PPM Images, Text-based Scripting</h2>
                  <p>
                    - MVC - Command Design Pattern  - Object
                    Adapter Pattern
                    <br></br>
                    <br></br>
                  </p>
                </div>
              </div>
              <h2>Week 2 : Support for Conventional Image Formats and Filtering </h2>
              <div className="imageWithTextRow">
                <p>
                - Object
                    Adapter Pattern
                  <br></br>
                  <br></br>

                </p>
              </div>
              <h2>Week 3 : Swing GUI and Histogram </h2>
              <CaptionedImage
                src={"/res/papertradeweb/stockSearchAndTrending.png"}
                id={"stockSearchAndTrendingImg"}
                caption={
                  "The Stock Search Form and Trending Ten Stocks List (the most volatile stocks according to the IEXCloud API)"
                }
              />
              <p>
                Once again, I consulted Google for advice on what a backend even
                was and which one I should choose. Being somewhat intimidated by
                backends, I decided to opt for a NoSQL database as I did not
                want to get lost learning an entire new language (in hindsight,
                I now understand that SQL isn't too complicated, but I probably
                still made a good decision), which led me to choose MongoDB. To
                manage the server, I chose to use Node.js and Express.js,
                primarily because it seemed like there were many resources
                online that I could use to troubleshoot development.
                <br></br>
                <br></br>
                In particular, throughout the backend development process I
                heavily relied on a MERN stack tutorial created by MongoDB
                (https://www.mongodb.com/languages/mern-stack-tutorial). I
                modified the code from the tutorial to store data relevant to my
                purposes; a user's available cash, the stocks they owned, the
                quantity they owned, and more. Without this tutorial, I would
                have been pretty lost, even after having completed this, I am
                still not particularly confident in backend development, and so
                it is certainly something that I want to spend more time on in
                the future.
              </p>
              <h2>Putting it all together - MERN</h2>
              <CaptionedImage
                src={"/res/papertradeweb/dashboard.png"}
                id={"paperTradeDashboardImg"}
                caption={"The PaperTrade Dashboard"}
              />
              <p>
                After having somehow assembled the backend, I was succesfully
                able to make API calls from the frontend, allowing my website to
                finally store data across sessions. However, it was at this
                point that I found myself needing to make changes to my
                frontend. Because I had initially created the frontend with zero
                idea about how the backend would come into play, much of the
                code regarding buying and selling stocks that I had written did
                not easily interface with the backend.
                <br></br>
                <br></br>
                For example, I had initially stored a user's stocks and cash
                data completely on the frontend as React state variables, with
                no reference to a database. Consequently, when a user bought or
                sold a stock, data was only updated on the client side, the
                frontend managed all of the logic; checking if the user has
                sufficient cash, or whether they owned the stock they were
                trying to sell. However, upon introducing a backend, I was now
                encountering issues where users buying stocks that they already
                owned created multiple rows in their portfolio table, when there
                should instead be only one row but with the quantity originally
                owned added to the quantity just bought. Because of this, I
                ended up needing to modify lots of existing frontend code to
                ensure that the client side state was appropriately in sync with
                the backend, such that the content displayed to the user was
                accurate to the user's data in the database.
                <br></br>
                <br></br>
                Nonetheless, I eventually managed to remedy these issues and had
                a functional website which allowed the user to buy and sell
                stocks, across sessions. My task now was to create a login
                system to allow this for multiple users.
              </p>
              <h2>Login System </h2>
              <div className="imageWithTextRow">
                <CaptionedImage
                  src={"/res/papertradeweb/loginCropped.png"}
                  id={"loginCroppedImg"}
                  caption={"Login page"}
                />
                <p>
                  In order to implement the login system, I heavily relied on
                  another tutorial created by the YouTube channel Traversy Media
                  (https://www.youtube.com/watch?v=USaB1adUHM0&list=PLillGF-RfqbbiTGgA77tGO426V3hRF9iE&index=10).
                  This process involved making changes to my backend to ensure
                  that certain API calls required a valid token, such that the
                  database could not be arbitrarily modified by any API request
                  and instead could only be modified provided a successful
                  login.
                </p>
              </div>
            </div>
          </div>

          <div className="learntContainer">
            <h1>Lessons Learnt</h1>
            <p>
              At this point, I am pretty happy with the website and do not plan
              to add any additional features. That being said, I do recognize
              that it is far from perfect and many of the ways that I have
              implemented things could be improved. Here are some of things that
              I would try to do in the future:
            </p>
            <ul>
              <li>
                Before beginning coding, plan out the entire project as much as
                possible. In particular, make sure that the frontend is written
                with a clear understanding of where API calls will need to be
                made, what those API calls will return, and how to manage state
                accordingly.
              </li>
              <li>
                Don't be afraid to use new libraries / frameworks. Although it
                is good to understand the underlying technologies (eg: coding in
                vanilla Javascript rather than React), there is a reason why
                they are used, and that is to make things easier for you. In
                particular, I would like to try using UI libraries such as
                MaterialUI in the future.
              </li>
              <li>
                Use TypeScript as much as possible. TypeScript is your friend,
                and helps you understand your code and use it more predictably.
                There are many type declarations that are optional, such as
                function return types, that you should opt to use almost always,
                even if it is obvious.
              </li>
              <li>
                Specific to React, during planning, take better consideration as
                to whether a component should be a functional component or a
                class component. Although there isn't much difference, if a
                component has many state variables, its probably easier to have
                a single setState function rather than 10+ useState hooks.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
